export * from "./menu.service";
export * from "./sub-menu.service";



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/menu/index.ts